import { initPublicHeader } from './header';

import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

document.addEventListener('DOMContentLoaded', () => {
    initPublicHeader();

    const videoSection = document.querySelector('#video-center-section');
    const articleSection = document.querySelector('#articles-section');

    if (!videoSection || !articleSection) {
        return;
    }

    let player = null;

    function getVideoNotSupportedText() {
        return videoSection.dataset.videoNotSupported || '';
    }

    function getNoVideoFileText() {
        return videoSection.dataset.noVideoFile || '';
    }

    function showNoVideo(videoContainer) {
        videoContainer.replaceChildren();

        const wrapper = document.createElement('div');
        wrapper.className = 'no-video-available text-center py-5';

        const message = document.createElement('p');
        message.className = 'fs-5';
        message.textContent = getNoVideoFileText();

        wrapper.appendChild(message);
        videoContainer.appendChild(wrapper);
    }

    function loadLocalVideo(videoUrl, videoType, videoContainer) {
        if (player) {
            player.destroy();
            player = null;
        }

        // Create new video element
        const videoElement = document.createElement('video');
        videoElement.id = 'local-video-player';
        videoElement.className = 'plyr__video';
        videoElement.setAttribute('playsinline', '');
        videoElement.setAttribute('controls', '');
        videoElement.setAttribute('preload', 'metadata');
        videoElement.setAttribute('width', '560');
        videoElement.setAttribute('height', '315');

        // Add main video source
        const mainSource = document.createElement('source');
        mainSource.src = videoUrl;
        mainSource.type = videoType;
        videoElement.appendChild(mainSource);

        // Add fallback message
        const fallback = document.createElement('p');
        fallback.textContent = getVideoNotSupportedText();
        videoElement.appendChild(fallback);

        // Clear container add add new video
        videoContainer.replaceChildren(videoElement);

        // Initialize Plyr player
        player = new Plyr('#local-video-player', {
            autoplay: false,
            muted: false,
            controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
            settings: ['quality', 'speed'],
            loop: { active: false },
            ratio: '16:9',
            hideControls: true,
            clickToPlay: true,
        });
    }

    function setupVideoInteractions() {
        const videoItems = videoSection.querySelectorAll('.video-item');
        const videoContainer = videoSection.querySelector('.local-video-container');

        if (!videoContainer) {
            return;
        }

        function initializeFirstVideo() {
            if (videoItems.length === 0) {
                return;
            }

            const firstVideo = videoItems[0];
            const videoUrl = firstVideo.dataset.videoUrl;
            const videoType = firstVideo.dataset.videoType;

            if (videoUrl) {
                loadLocalVideo(videoUrl, videoType, videoContainer);
            } else {
                showNoVideo(videoContainer);
            }
        }

        initializeFirstVideo();

        videoItems.forEach((item) => {
            item.addEventListener('click', function () {
                videoItems.forEach((videoItem) => videoItem.classList.remove('active'));
                this.classList.add('active');
                const videoUrl = this.dataset.videoUrl;
                const videoType = this.dataset.videoType;

                if (videoUrl) {
                    loadLocalVideo(videoUrl, videoType, videoContainer);
                } else {
                    showNoVideo(videoContainer);
                }
            });
        });
    }

    setupVideoInteractions();

    videoSection.addEventListener('click', (event) => {
        const link = event.target.closest('.video-pagination a');
        if (!link) return;

        event.preventDefault();
        const url = link.getAttribute('href');
        if (!url) return;

        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then((response) => response.text())
            .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newSection = doc.querySelector('#video-center-section');
                if (newSection) {
                    videoSection.innerHTML = newSection.innerHTML;
                    setupVideoInteractions();
                }
            })
            .catch((error) => console.error(error));
    });

    articleSection.addEventListener('click', (event) => {
        const link = event.target.closest('.pagination a');
        if (!link) return;

        event.preventDefault();
        const url = link.getAttribute('href');
        if (!url) return;

        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then((response) => response.text())
            .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newSection = doc.querySelector('#articles-section');
                if (newSection) {
                    articleSection.innerHTML = newSection.innerHTML;
                }
            })
            .catch((error) => console.error(error));
    });
});
